import React, {createContext, useEffect, useState} from 'react';
import {BrowserRouter} from 'react-router-dom'
import AppRouter from "./components/AppRouter";
import ScrollToTop from "./utils/ScrollToTop";
import i18next from "i18next";
import getLanguagePath from "./utils/getLanguagePath";
import Popup from "./components/Popup";

export const LanguageContext = createContext([]);
export const PopupContext = createContext([]);
export const MobileMenuContext = createContext([]);

function App() {
    const [languageContext, setLanguageContext] = useState({});
    const [popupContext, setPopupContext] = useState('');
    const [mobileMenu, setMobileMenu] = useState(null);

    useEffect(() => {
        function screenHeight() {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        }

        screenHeight();
        window.addEventListener('resize', function () {
            setTimeout(function () {
                screenHeight();
            }, 400);
        });
    });

    useEffect(() => {
        i18next.changeLanguage(getLanguagePath());
    });

    return (
        <LanguageContext.Provider value={[languageContext, setLanguageContext]}>
            <PopupContext.Provider value={[popupContext, setPopupContext]}>
                <MobileMenuContext.Provider value={[mobileMenu, setMobileMenu]}>
                    <BrowserRouter>
                        <ScrollToTop/>
                        <AppRouter/>
                        {popupContext && <Popup/>}
                    </BrowserRouter>
                </MobileMenuContext.Provider>
            </PopupContext.Provider>
        </LanguageContext.Provider>
    );
}

export default App;
